import { DOCUMENT } from '@angular/common';
import { type HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { APP_CONFIG } from '@core/config/app-config.tokens';
import { SKIP_HTTP_SESSION_AUTH } from '@core/http/http-context.tokens';
import { HTTP_HEADER_CONTRIBUTORS, isApiRequestUrl } from '@core/http/http-header-contributor';

export const httpHeadersInterceptor: HttpInterceptorFn = (request, next) => {
  const appConfig = inject(APP_CONFIG);
  const document = inject(DOCUMENT);
  const contributors = inject(HTTP_HEADER_CONTRIBUTORS);
  const skipSessionAuth = request.context.get(SKIP_HTTP_SESSION_AUTH);
  const isApiRequest = isApiRequestUrl(request.url, appConfig.apiBaseUrl, document.baseURI);
  let nextRequest =
    isApiRequest && !skipSessionAuth && !request.withCredentials
      ? request.clone({ withCredentials: true })
      : request;

  let headers = nextRequest.headers;
  let hasChanges = false;

  for (const contributor of contributors) {
    const values = contributor.contribute(nextRequest, { skipSessionAuth });

    if (!values) {
      continue;
    }

    for (const [name, value] of Object.entries(values)) {
      if (!value || headers.has(name)) {
        continue;
      }

      headers = headers.set(name, value);
      hasChanges = true;
    }
  }

  if (hasChanges) {
    nextRequest = nextRequest.clone({ headers });
  }

  return next(nextRequest);
};
